/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */

export type CreateRoleRequestPermissionsItem = typeof CreateRoleRequestPermissionsItem[keyof typeof CreateRoleRequestPermissionsItem];


export const CreateRoleRequestPermissionsItem = {
  orgread: 'org.read',
  orgwrite: 'org.write',
  storesread: 'stores.read',
  storeswrite: 'stores.write',
  settingsread: 'settings.read',
  settingswrite: 'settings.write',
  staffread: 'staff.read',
  staffmanage: 'staff.manage',
  api_keysmanage: 'api_keys.manage',
  paymentsmanage: 'payments.manage',
  productsread: 'products.read',
  productswrite: 'products.write',
  attributeswrite: 'attributes.write',
  collectionswrite: 'collections.write',
  mediawrite: 'media.write',
  inventoryread: 'inventory.read',
  inventorywrite: 'inventory.write',
  configuratorread: 'configurator.read',
  configuratorwrite: 'configurator.write',
  customersread: 'customers.read',
  customerswrite: 'customers.write',
  ordersread: 'orders.read',
  orderswrite: 'orders.write',
  ordersedit: 'orders.edit',
  orderscancel: 'orders.cancel',
  ordersrefund: 'orders.refund',
  fulfillmentswrite: 'fulfillments.write',
  returnswrite: 'returns.write',
  discountsread: 'discounts.read',
  discountswrite: 'discounts.write',
  gift_cardsread: 'gift_cards.read',
  gift_cardswrite: 'gift_cards.write',
  contentread: 'content.read',
  contentwrite: 'content.write',
  reviewsmoderate: 'reviews.moderate',
  notificationswrite: 'notifications.write',
  reportsread: 'reports.read',
  importsrun: 'imports.run',
  exportsrun: 'exports.run',
  webhooksmanage: 'webhooks.manage',
  auditread: 'audit.read',
  docsread: 'docs.read',
  conversationsread: 'conversations.read',
  conversationswrite: 'conversations.write',
  conversationsmanage: 'conversations.manage',
  helpread: 'help.read',
  helpwrite: 'help.write',
  socialread: 'social.read',
  socialwrite: 'social.write',
  auctionsread: 'auctions.read',
  auctionswrite: 'auctions.write',
} as const;
